import { connect } from 'react-redux';
import { provideHooks } from 'redial';
import { withRouter } from 'react-router';
import { deslugifyParam } from 'utils/url';
import { CRITEO_ADS_BETA_FEATURE } from 'apps/analytics/constants';

import Bop from '../components/Bop';
import {
  ensureProductDetails,
  fetchStaticContent,
  fetchSimilarProducts,
  fetchRecommendations,
  fetchRecipes,
  fetchCriteoSponsoredProducts,
} from 'apps/products/actions/productDetails';
import { fetchReviews, fetchReviewSummary } from 'apps/products/actions/reviews';
import { fetchSubscriptionForProduct } from 'apps/subscriptions/actions/subscriptions';
import { isUserLoggedIn } from 'apps/user/helpers';
import ProductsPageRoute from '../../productsPages/utils/ProductsPageRoute';
import { fetchFeedbackCorrectionTypes, postFeedback } from '../actions/feedback';
import { ensureMetaData } from 'apps/meta/actions/meta';
import { META_BOP, getPageMetaData } from 'apps/meta/utils';

const EMPTY_PRODUCT_DETAILS = {};
const getSkuFromParams = (params) => deslugifyParam(params.sku);

export default withRouter(provideHooks({
  fetch: ({ params, dispatch, store, location }) => {
    const { parentContainer } = location ? location.query : store.getState().http.query;
    const sku = getSkuFromParams(params);
    const { user } = store.getState();
    const isLoggedIn = isUserLoggedIn(user);
    const isCriteoAdEnabled = user.betaFeatures.includes(CRITEO_ADS_BETA_FEATURE);

    if (!sku) {
      return false;
    }

    return Promise.all([
      dispatch(ensureProductDetails(sku, parentContainer === 'CHECKOUTPURGE')),
      () => (isLoggedIn ? dispatch(fetchSubscriptionForProduct(sku)) : true),
      dispatch(fetchReviews(sku)),
      dispatch(fetchReviewSummary(sku)),
      dispatch(fetchStaticContent()),
      isCriteoAdEnabled && dispatch(fetchCriteoSponsoredProducts(sku)),
      dispatch(ensureMetaData()),
    ]);
  },
  defer: ({ params, dispatch }) => {
    const sku = getSkuFromParams(params);

    if (!sku) {
      return;
    }

    dispatch(fetchRecommendations(sku));
    dispatch(fetchFeedbackCorrectionTypes());
    dispatch(fetchRecipes(sku));
    dispatch(fetchSimilarProducts(sku));
  },
})(connect((state, ownProps) => {
  const sku = getSkuFromParams(ownProps.params);
  const productsPageRoute = new ProductsPageRoute(ownProps.location, ownProps.params);
  const routeString = productsPageRoute.toString();
  const { parentContainer } = state.http.query;
  const isFlashSale = parentContainer === 'CHECKOUTPURGE';
  const { externalAdData } = ownProps.location.state || {};
  const analyticsContextData = externalAdData ? { externalAdData } : {};

  return {
    analyticsContextData,
    basketItems: state.basket.items,
    betaFeatures: state.user.betaFeatures,
    deliverySlot: state.deliverySlot,
    disclaimerRegularMessage: state.externalisedStrings['product.disclaimer.regularMessage'],
    feedbackCorrectionTypes: state.products.feedbackCorrectionTypes,
    isFlashSale,
    isLoggedIn: isUserLoggedIn(state.user),
    loggedOutBasket: state.user.betaFeatures.includes('LOGGED_OUT_BASKET'),
    pageMetaData: getPageMetaData(META_BOP, state.meta),
    product: state.products.productsBySku[sku],
    productBanners: state.products.banners,
    productDetails: state.products.productDetailsBySku[sku] || EMPTY_PRODUCT_DETAILS,
    productsBySku: state.products.productsBySku,
    productsPage: state.catalogue.productsPagesByRoute[routeString],
    routeString,
    showRegulars: state.user.features.includes('SUBSCRIPTIONS'),
  };
}, {
  postFeedback,
})(Bop)));
